import { ApiPropertyOptional } from '@nestjs/swagger';
import { IsNumber, IsOptional, IsString, IsUUID, Min } from 'class-validator';

export class UpdatePedidoItemDto {
  @ApiPropertyOptional({ description: 'ID de la presentación' })
  @IsOptional()
  @IsUUID()
  presentacion_id?: string;

  @ApiPropertyOptional({ description: 'Cantidad solicitada' })
  @IsOptional()
  @IsNumber()
  @Min(0.0001)
  cantidad?: number;

  @ApiPropertyOptional({ description: 'Precio negociado' })
  @IsOptional()
  @IsNumber()
  @Min(0)
  precio_negociado?: number;

  @ApiPropertyOptional({ description: 'Porcentaje de descuento' })
  @IsOptional()
  @IsNumber()
  @Min(0)
  descuento_porcentaje?: number;

  @ApiPropertyOptional({ description: 'Observación del item' })
  @IsOptional()
  @IsString()
  observacion?: string;
}
